import Products from './products';
import Records from './records';

export const SalesTerminal = () => {
	return (
		<section id="product-wrapper" className="flex h-full">
			<Products />
			<Records />
		</section>
	);
};
